import { useEffect } from 'react';
import { GTM_ID } from '@env';
import { GtmClient } from '@photosi/gtm-service';

// const INTERACTION_EVENTS = ['click', 'keydown', 'scroll', 'touchstart'];

export const useGtmService = () => {
  useEffect(() => {
    if (!GtmClient.isInitialized()) {
      GtmClient.init({ gtmId: GTM_ID });
    }

    //   const handleFirstInteraction = () => {
    //     GtmClient.emitEvent({ event: 'activatorEditorUnico' });
    //     INTERACTION_EVENTS.forEach(event => window.removeEventListener(event, handleFirstInteraction));
    //   };

    //   INTERACTION_EVENTS.forEach(event => window.addEventListener(event, handleFirstInteraction, { passive: true }));

    //   return () => {
    //     INTERACTION_EVENTS.forEach(event => window.removeEventListener(event, handleFirstInteraction));
    //   };
  }, []);
};
